import { render, staticRenderFns } from "./ArticleCardHorizontal.vue?vue&type=template&id=3d28e240"
import script from "./ArticleCardHorizontal.vue?vue&type=script&lang=js"
export * from "./ArticleCardHorizontal.vue?vue&type=script&lang=js"
import style0 from "./ArticleCardHorizontal.vue?vue&type=style&index=0&id=3d28e240&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports